import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=745225d3&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=745225d3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745225d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745225d3')) {
      api.createRecord('745225d3', component.options)
    } else {
      api.reload('745225d3', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=745225d3&scoped=true", function () {
      api.rerender('745225d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/memberUnite/components/Add.vue"
export default component.exports